import React from 'react';
import './EmailAndCalendars.css';
import { NavLink } from 'react-router-dom';

import FlipCard from '../../../components/FlipCards/FlipCard';

const emailAndCalendars = ( props ) => {
	const cards = {
		emailTip: {
			side1: 'Email',
			side2: '<p><strong>Pro Tip:</strong></p><p>Use Outlook\'s "Flag for Follow Up" feature to keep track of emails that need responses or tasks that need action.</p>',
			icon: 'communication.email',
			side2class: 'bg-color-1'
		},
		calendarTip: {
			side1: 'Outlook',
			side2: '<p><strong>Pro Tip:</strong></p><p>Make sure your name is included in your calendar event titles!<br>Example: Jess – PTO.</p>',
			icon: 'communication.calendar',
			side2class: 'bg-color-1'
		}
	}
	return (
		<section id="EmailAndCalendars">
			<h2>Email <span>&</span> Calendars</h2>
			
			<div className="section">
				<FlipCard className="bg-gradient vertical invert" { ...cards.emailTip } />
				
				<div className="inner-section">
					<p>
						We use Microsoft Outlook for email. You can also access your email via the web at <a href="https://mail.idsi.com" target="_blank" rel="noopener noreferrer">https://mail.idsi.com</a>.
					</p>
					<p>
						Be sure to follow good email etiquette:
					</p>
					<ul>
						<li>
							Check and respond to email actively throughout the day.
						</li>
						<li>
							Set away messages when you're going to be out of the office.
						</li>
						<li>
							Only use Reply All when appropriate (or we'll make fun of you).
						</li>
					</ul>
					<p>
						<NavLink to='/super-tech-support'>Michael Magill</NavLink> will send you your username and initial password. You must change your password every 6 months for security purposes—you'll get a notification when yours needs to be updated.  Remember, using a password made up of <em>four random dictionary words</em> is more secure and easier to remember than something crazy.
					</p>
				</div>
			</div>
			
			<div className="section">
				<div className="inner-section">
					<p>
						We use a shared Outlook calendar for scheduling, appointments, and paid time off (PTO) notifications. Any changes to your normal schedule should be noted here. Talk to your project manager about other project- or office-specific calendars and policies.
					</p>
					<p>
						Accessing shared calendars is quick and easy. Check out the instructions below!
					</p>
				</div>
				<FlipCard className="bg-gradient vertical invert" { ...cards.calendarTip } />
			</div>
		</section>
	);
}

export default emailAndCalendars;



// WEBPACK FOOTER //
// ./src/pages/Communication/EmailAndCalendars/EmailAndCalendars.js